import { Box } from 'native-base';
import React, { useCallback, useState } from 'react';
import { ParentAgreementForm } from '../../components/auth/ParentAgreementForm';
import { useRegistrationSubmit } from '../../hooks/auth';
import { RegistrationStackScreenWithNavProps } from '../../navigation/RegistrationNavigation';
import { useAppDispatch, useAppSelector } from '../../store';
import { authActions, registrationActions } from '../../store/actions';
import { RegistrationData } from '../../store/registration/types';

type ParentAgreementScreenProps = { onRegistrationSuccess: () => void };

export const ParentAgreementScreen: React.FC<ParentAgreementScreenProps> = ({ onRegistrationSuccess }) => {
  const dispatch = useAppDispatch();

  const { currentUser } = useAppSelector((state) => state.auth);

  const [navigating, setNavigating] = useState(false);

  const { loading, disabled, handleSubmit } = useRegistrationSubmit<RegistrationData>({
    onDone: useCallback(() => {
      setNavigating(true);
      onRegistrationSuccess();
    }, []),
    onSubmit: useCallback(
      async (data) => {
        if (currentUser && data.mobilePhone) {
          await dispatch(
            authActions.updateCurrentUser({
              ...currentUser,
              receiveSmsNotifications: !!data.mobilePhone,
            }),
          ).unwrap();
        }

        return dispatch(registrationActions.submitRegistration({ registrationData: data }));
      },
      [currentUser, dispatch],
    ),
  });

  return (
    <Box flex={1}>
      <ParentAgreementForm
        loading={loading || navigating}
        disabled={disabled || navigating}
        onSubmit={(data) => handleSubmit(data)}
      />
    </Box>
  );
};
